import React from 'react';
import PropTypes from "prop-types";
import {iconCheck, iconLogo, iconWarning} from "../common/Icon";
import Menu from './Menu';
import Logout from "./Logout";
import {connect} from 'react-redux';

const propTypes = {
	accepted: PropTypes.bool.isRequired,
	guid: PropTypes.string,
	offer: PropTypes.object,
	rejected: PropTypes.bool.isRequired,
};

const defaultProps = {
	guid: undefined,
	offer: undefined,
};

const mapStateToProps = (state) => {
	return {
		offer: state.app.offer,
		accepted: state.app.accepted,
		rejected: state.app.rejected,
	};
};

class Header extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<header>
				<div className="top-header">
					{iconLogo()}
                    <Logout/>
				</div>
				{this.props.guid && <Menu guid={this.props.guid}/>}
				{(this.props.accepted || this.props.rejected) &&
					<div className={`status-bar status-bar--${this.props.accepted ? 'accepted': 'rejected'}`}>
						{this.props.accepted ? <span>{iconCheck()} Offer Accepted</span> : <span>{iconWarning()} Offer Rejected</span>}
					</div>
				}
			</header>
		);
	}
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default connect(mapStateToProps)(Header);
